import { createTheme } from "@mui/material/styles";

export const ExpoTheme = createTheme({
  palette: {
    primary: {
      main: "#2563EB",
      light: "#EEF4FF",
      dark: "#1D4ED8",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#4F46E5",
    },
    success: {
      main: "#16A34A",
      light: "#ECFDF3",
    },
    warning: {
      main: "#F59E0B",
      light: "#FFF7E6",
      dark: "#D97706",
    },
    danger: {
      main: "#DC2626",
      light: "#FEF2F2",
    },
    text: {
      primary: "#172033",
      secondary: "#667085",
      disabled: "#98A2B3",
    },
    background: {
      default: "#F7F9FC",
      paper: "#FFFFFF",
    },
    action: {
      hover: "rgba(37, 99, 235, 0.04)",
      hoverOpacity: 0.04,
      selected: "rgba(37, 99, 235, 0.08)",
      selectedOpacity: 0.08,
    },
  },
  typography: {
    fontFamily: [
      "Inter",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
    ].join(","),
    button: {
      textTransform: "none",
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "#FFFFFF",
          color: "#172033",
          boxShadow: "0px 1px 3px rgba(16, 24, 40, 0.06), 0px 1px 2px rgba(16, 24, 40, 0.04)",
          borderBottom: "1px solid #E7EAF0",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: "14px",
          border: "1px solid #E7EAF0",
          boxShadow: "0px 1px 3px rgba(16, 24, 40, 0.04), 0px 4px 12px rgba(16, 24, 40, 0.02)",
          transition: "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: "#FFFFFF",
          borderRight: "1px solid #E7EAF0",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "8px",
          boxShadow: "none",
          fontWeight: 600,
          "&:hover": {
            boxShadow: "none",
          },
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: "10px",
          margin: "3px 12px",
          padding: "9px 14px",
          transition: "all 0.2s ease-in-out",
          color: "#475467",
          "&:hover": {
            backgroundColor: "#F1F5F9",
            color: "#1E293B",
            "& .MuiListItemIcon-root": {
              color: "#2563EB",
            },
          },
          "&.Mui-selected": {
            backgroundColor: "#2563EB",
            color: "#FFFFFF",
            fontWeight: 600,
            "& .MuiListItemIcon-root": {
              color: "#FFFFFF",
            },
            "&:hover": {
              backgroundColor: "#1D4ED8",
            },
          },
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: "36px",
          color: "#64748B",
          transition: "color 0.2s ease-in-out",
        },
      },
    },
  },
});
